function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "chevron-left");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Invision",
  stroke: "none",
  strokeWidth: 1,
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "chevron-left",
  transform: "translate(0.590149, 0.749921)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5817264,0.166094466 C8.71602342,0.288789436 8.78313288,0.456640884 8.78313288,0.625078841 C8.78313288,0.777070686 8.72821078,0.929024383 8.61711726,1.04929702 L1.51024207,8.75007884 L8.58446106,16.4492978 C8.81883606,16.7032041 8.80418763,17.0992972 8.54906246,17.3325016 C8.29515621,17.5668766 7.90101573,17.551017 7.66664073,17.2977127 L0.166640729,9.17271273 C-0.0555469096,8.93224375 -0.0555469096,8.56490032 0.166640729,8.32427518 L7.66664073,0.19927518 C7.93328866,-0.0522647656 8.32782015,-0.0682805336 8.5817264,0.166094466 Z",
  id: "Path"
})));
const SvgIconChevron = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "19px",
    viewBox: "0 0 10 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconChevron, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-chevron.b8822c00.svg";
export { ForwardRef as ReactComponent };